import React, { useRef, useState } from "react";
import "./Apply_Modal.css";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import SuccesfullModal from "../SuccesfullModal/SuccesfullModal";

function Apply_Modal(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const { control, handleSubmit, getValues, setValue } = useForm();
  const fileInputRef = useRef(null); // Reference for the file input
  const [fileName, setFileName] = useState("No Chosen File"); // State to hold file name

  const onSubmit = (data) => {
    console.log(data);
  };

  // Example options for the experience dropdown
  const experienceOptions = [
    { value: "0-1", label: "0-1 years" },
    { value: "1-3", label: "1-3 years" },
    { value: "3-5", label: "3-5 years" },
    { value: "5+", label: "5+ years" },
  ];

  // Custom styles for react-select to remove outline and box shadow on focus
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
    }),
  };

  const handleFileSelect = () => {
    fileInputRef.current.click(); // Trigger click on hidden file input
  };

  const onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name); // Update file name in the state
      setValue("resumeFile", selectedFile); // Store the file in form state if needed
    }
  };
  return (
    <>
      <section className="Apply_Modal_modal">
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Apply_Modal"
        >
          <div className="upper-section">
            {/* <h2>Post Your Resume / Registration</h2> */}
            <h4>Post Your Resume / Registration</h4>
            <div className="overlay-holder"></div>
          </div>

          <Modal.Header closeButton></Modal.Header>
          <Modal.Body >
          
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="main-form-section mt-4">
                <div className=" row">
                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>First Name*</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="Enter First Name"
                          />
                        </InputGroup>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>Last Name*</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="Enter Last Name"
                          />
                        </InputGroup>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>Email*</Form.Label>
                        <InputGroup>
                          <Form.Control type="text" placeholder="Enter Email" />
                        </InputGroup>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>Address*</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="Enter Address"
                          />
                        </InputGroup>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        {/* <Controller
                      name="contact_no"
                      control={control}
                      render={({ field }) => (
                        <div style={{ position: "relative" }}> */}
                        <Form.Label>Mobile Number*</Form.Label>
                        <PhoneInput
                          country={"in"}
                          searchPlaceholder="Enter Mobile Number"
                          value={getValues("contact_no")} // Manually bind value
                          onChange={(phone) => setValue("contact_no", phone)} // Manually handle change
                          inputProps={{
                            searchPlaceholder: "Enter Mobile Number", // Use inputProps to pass the placeholder
                          }}
                        />
                        {/* </div>
                      )}
                    /> */}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>Experience*</Form.Label>

                        <Select
                          options={experienceOptions}
                          placeholder="Select Experience"
                          styles={customSelectStyles}
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-12 col-12">
                    <div className="input-div">
                      <Form.Group>
                        <Form.Label>Upload Resume*</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="No Chosen File"
                            value={fileName} // Display selected file name
                            readOnly
                          />
                          {/* Hidden file input */}
                          <Form.Control
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={onFileChange} // Handle file selection
                          />
                          <Button
                            className="Choose-File-btn"
                            onClick={handleFileSelect}
                          >
                            Choose File
                          </Button>
                        </InputGroup>
                        <Form.Text>
                          Upload Your Resume* (upload only .doc, .docx , .rtf ,
                          .pdf files)
                        </Form.Text>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-12 col-12">
                    <div className="btn-div">
                      <Button
                        className="submit-btn"
                        type="submit"
                        onClick={() => {
                          setModalShow(true);
                          props.onHide();
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </section>

      <SuccesfullModal
        message={"Form submitted successfully !"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Apply_Modal;
